import { createContext, ReactNode } from "react";
// mine:
import { GameManager } from "@/app/lib/game-state/game-manager";
import { AnyGameObj } from "@/app/lib/game-state/game-types";

import UI from "@/app/lib/ui/ui";

export const GameManagerContext = createContext<GameManager | null>(null);
export const ActiveGameContext = createContext<AnyGameObj | null>(null);
export const UIContext = createContext<UI | null>(null);

export const Contexts = {
    GameManager: GameManagerContext,
    ActiveGame: ActiveGameContext,
    UI: UIContext,
}

type AllContextsProps = {
    children: ReactNode,
    gameManager: GameManager,
    activeGame: AnyGameObj,
    ui: UI,
}

export function AllContexts({ children, gameManager, activeGame, ui } : AllContextsProps) {
    return(
        <>
            <Contexts.GameManager value={gameManager}>
            <Contexts.ActiveGame value={activeGame}>
            <Contexts.UI value={ui}>
                {children}
            </Contexts.UI>
            </Contexts.ActiveGame>
            </Contexts.GameManager>
        </>
    )
}